/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-16 10:04:39
 * @LastEditTime: 2020-12-03 19:06:00
 * @LastEditors: wutt
 */
import { DeploymentEnvironmentType } from "./SystemConfigConstants.js";

export class ServiceUrlConfig {

    constructor() {
        this.token=null;
        this.envType=null;
    }

    static getInstance() {
        if (!ServiceUrlConfig._instance) {
            ServiceUrlConfig._instance = new ServiceUrlConfig();
        }

        return ServiceUrlConfig._instance;
    }



    init() {
        if (!this.envType) return;

        if (this.envType === DeploymentEnvironmentType.publicNetwork) {

            ServiceUrlConfig.tdt_vec_c_url = ServiceUrlConfig.tdt_public_vec_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cva_c_url = ServiceUrlConfig.tdt_public_cva_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_img_c_url = ServiceUrlConfig.tdt_public_img_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cia_c_url = ServiceUrlConfig.tdt_public_cia_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_ter_c_url = ServiceUrlConfig.tdt_public_ter_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cta_c_url = ServiceUrlConfig.tdt_public_cta_c_url +"?tk="+ this.token;

            ServiceUrlConfig.tdt_vec_w_url = ServiceUrlConfig.tdt_public_vec_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cva_w_url = ServiceUrlConfig.tdt_public_cva_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_img_w_url = ServiceUrlConfig.tdt_public_img_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cia_w_url = ServiceUrlConfig.tdt_public_cia_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_ter_w_url = ServiceUrlConfig.tdt_public_ter_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cta_w_url = ServiceUrlConfig.tdt_public_cta_w_url +"?tk="+ this.token;
            
            
            ServiceUrlConfig.tdt_xyz_vec_c_url = ServiceUrlConfig.tdt_xyz_public_vec_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cva_c_url = ServiceUrlConfig.tdt_xyz_public_cva_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_img_c_url = ServiceUrlConfig.tdt_xyz_public_img_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cia_c_url = ServiceUrlConfig.tdt_xyz_public_cia_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_ter_c_url = ServiceUrlConfig.tdt_xyz_public_ter_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cta_c_url = ServiceUrlConfig.tdt_xyz_public_cta_c_url +"&tk="+ this.token;

            ServiceUrlConfig.tdt_xyz_vec_w_url = ServiceUrlConfig.tdt_xyz_public_vec_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cva_w_url = ServiceUrlConfig.tdt_xyz_public_cva_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_img_w_url = ServiceUrlConfig.tdt_xyz_public_img_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cia_w_url = ServiceUrlConfig.tdt_xyz_public_cia_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_ter_w_url = ServiceUrlConfig.tdt_xyz_public_ter_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cta_w_url = ServiceUrlConfig.tdt_xyz_public_cta_w_url +"&tk="+ this.token;
            

            ServiceUrlConfig.tdt_service_base_url=ServiceUrlConfig.tdt_service_public_base_url;
            ServiceUrlConfig.tdt_service_busTransfer_url = ServiceUrlConfig.tdt_service_public_busTransfer_url;
            ServiceUrlConfig.tdt_service_district_url = ServiceUrlConfig.tdt_service_public_district_url;
            ServiceUrlConfig.tdt_service_drive_url = ServiceUrlConfig.tdt_service_public_drive_url;
            ServiceUrlConfig.tdt_service_query_url = ServiceUrlConfig.tdt_service_public_query_url;
            ServiceUrlConfig.tdt_service_reverse_address_url=ServiceUrlConfig.tdt_service_public_reverse_address_url;
            
            
            
            ServiceUrlConfig.platform_base_url=ServiceUrlConfig.platform_base_url_public;
            
        }
        else if (this.envType === DeploymentEnvironmentType.governmentNetWork) {

            ServiceUrlConfig.tdt_vec_c_url = ServiceUrlConfig.tdt_government_vec_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cva_c_url = ServiceUrlConfig.tdt_government_cva_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_img_c_url = ServiceUrlConfig.tdt_government_img_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cia_c_url = ServiceUrlConfig.tdt_government_cia_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_ter_c_url = ServiceUrlConfig.tdt_government_ter_c_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cta_c_url = ServiceUrlConfig.tdt_government_cta_c_url +"?tk="+ this.token;
            

            ServiceUrlConfig.tdt_vec_w_url = ServiceUrlConfig.tdt_government_vec_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cva_w_url = ServiceUrlConfig.tdt_government_cva_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_img_w_url = ServiceUrlConfig.tdt_government_img_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cia_w_url = ServiceUrlConfig.tdt_government_cia_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_ter_w_url = ServiceUrlConfig.tdt_government_ter_w_url +"?tk="+ this.token;
            ServiceUrlConfig.tdt_cta_w_url = ServiceUrlConfig.tdt_government_cta_w_url +"?tk="+ this.token;
            

            ServiceUrlConfig.tdt_xyz_vec_c_url = ServiceUrlConfig.tdt_xyz_government_vec_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cva_c_url = ServiceUrlConfig.tdt_xyz_government_cva_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_img_c_url = ServiceUrlConfig.tdt_xyz_government_img_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cia_c_url = ServiceUrlConfig.tdt_xyz_government_cia_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_ter_c_url = ServiceUrlConfig.tdt_xyz_government_ter_c_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cta_c_url = ServiceUrlConfig.tdt_xyz_government_cta_c_url +"&tk="+ this.token;

            ServiceUrlConfig.tdt_xyz_vec_w_url = ServiceUrlConfig.tdt_xyz_government_vec_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cva_w_url = ServiceUrlConfig.tdt_xyz_government_cva_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_img_w_url = ServiceUrlConfig.tdt_xyz_government_img_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cia_w_url = ServiceUrlConfig.tdt_xyz_government_cia_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_ter_w_url = ServiceUrlConfig.tdt_xyz_government_ter_w_url +"&tk="+ this.token;
            ServiceUrlConfig.tdt_xyz_cta_w_url = ServiceUrlConfig.tdt_xyz_government_cta_w_url +"&tk="+ this.token;
            
            ServiceUrlConfig.tdt_service_base_url=ServiceUrlConfig.tdt_service_government_base_url;
            ServiceUrlConfig.tdt_service_busTransfer_url = ServiceUrlConfig.tdt_service_government_busTransfer_url;
            ServiceUrlConfig.tdt_service_district_url = ServiceUrlConfig.tdt_service_government_district_url;
            ServiceUrlConfig.tdt_service_drive_url = ServiceUrlConfig.tdt_service_government_drive_url;
            ServiceUrlConfig.tdt_service_query_url = ServiceUrlConfig.tdt_service_government_query_url;
            ServiceUrlConfig.tdt_service_reverse_address_url=ServiceUrlConfig.tdt_service_government_reverse_address_url;
            
            


            
            ServiceUrlConfig.platform_base_url=ServiceUrlConfig.platform_base_url_government;
        }

        ServiceUrlConfig.platform_tdtsso_fullLogin = ServiceUrlConfig.platform_base_url + ServiceUrlConfig.platform_tdtsso_login;
        ServiceUrlConfig.platform_tdtsso_fullLogout = ServiceUrlConfig.platform_base_url + ServiceUrlConfig.platform_tdtsso_logout;
        
    }
}

ServiceUrlConfig._instance = null;

ServiceUrlConfig.tdt_vec_c_url = null;
ServiceUrlConfig.tdt_cva_c_url = null;
ServiceUrlConfig.tdt_img_c_url = null;
ServiceUrlConfig.tdt_cia_c_url = null;
ServiceUrlConfig.tdt_ter_c_url = null;
ServiceUrlConfig.tdt_cta_c_url = null;

ServiceUrlConfig.tdt_vec_w_url = null;
ServiceUrlConfig.tdt_cva_w_url = null;
ServiceUrlConfig.tdt_img_w_url = null;
ServiceUrlConfig.tdt_cia_w_url = null;
ServiceUrlConfig.tdt_ter_w_url = null;
ServiceUrlConfig.tdt_cta_w_url = null;


ServiceUrlConfig.tdt_xyz_vec_c_url=null;
ServiceUrlConfig.tdt_xyz_cva_c_url=null;
ServiceUrlConfig.tdt_xyz_img_c_url=null;
ServiceUrlConfig.tdt_xyz_cia_c_url=null;
ServiceUrlConfig.tdt_xyz_ter_c_url=null;
ServiceUrlConfig.tdt_xyz_cta_c_url=null;

ServiceUrlConfig.tdt_xyz_vec_w_url=null;
ServiceUrlConfig.tdt_xyz_cva_w_url=null;
ServiceUrlConfig.tdt_xyz_img_w_url=null;
ServiceUrlConfig.tdt_xyz_cia_w_url=null;
ServiceUrlConfig.tdt_xyz_ter_w_url=null;
ServiceUrlConfig.tdt_xyz_cta_w_url=null;

ServiceUrlConfig.tdt_service_base_url=null;
ServiceUrlConfig.tdt_service_busTransfer_url = null;
ServiceUrlConfig.tdt_service_district_url = null;
ServiceUrlConfig.tdt_service_drive_url = null;
ServiceUrlConfig.tdt_service_query_url = null;
ServiceUrlConfig.tdt_service_reverse_address_url=null;


ServiceUrlConfig.tdt_public_base_url="http://t{0-7}.tianditu.gov.cn";
ServiceUrlConfig.tdt_public_vec_c_url =ServiceUrlConfig.tdt_public_base_url + "/vec_c/wmts";
ServiceUrlConfig.tdt_public_cva_c_url =ServiceUrlConfig.tdt_public_base_url + "/cva_c/wmts";
ServiceUrlConfig.tdt_public_img_c_url =ServiceUrlConfig.tdt_public_base_url + "/img_c/wmts";
ServiceUrlConfig.tdt_public_cia_c_url =ServiceUrlConfig.tdt_public_base_url + "/cia_c/wmts";
ServiceUrlConfig.tdt_public_ter_c_url =ServiceUrlConfig.tdt_public_base_url + "/ter_c/wmts";
ServiceUrlConfig.tdt_public_cta_c_url =ServiceUrlConfig.tdt_public_base_url + "/cta_c/wmts";

ServiceUrlConfig.tdt_public_vec_w_url =ServiceUrlConfig.tdt_public_base_url + "/vec_w/wmts";
ServiceUrlConfig.tdt_public_cva_w_url =ServiceUrlConfig.tdt_public_base_url + "/cva_w/wmts";
ServiceUrlConfig.tdt_public_img_w_url =ServiceUrlConfig.tdt_public_base_url + "/img_w/wmts";
ServiceUrlConfig.tdt_public_cia_w_url =ServiceUrlConfig.tdt_public_base_url + "/cia_w/wmts";
ServiceUrlConfig.tdt_public_ter_w_url =ServiceUrlConfig.tdt_public_base_url + "/ter_w/wmts";
ServiceUrlConfig.tdt_public_cta_w_url =ServiceUrlConfig.tdt_public_base_url + "/cta_w/wmts";


ServiceUrlConfig.tdt_xyz_public_base_url="https://t{0-7}.tianditu.gov.cn/DataServer?";
ServiceUrlConfig.tdt_xyz_public_vec_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=vec_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cva_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cva_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_img_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=img_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cia_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cia_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_ter_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=ter_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cta_c_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cta_c&x={x}&y={y}&l={z}";

ServiceUrlConfig.tdt_xyz_public_vec_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=vec_w&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cva_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cva_w&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_img_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=img_w&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cia_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cia_w&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_ter_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=ter_w&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_public_cta_w_url =ServiceUrlConfig.tdt_xyz_public_base_url + "T=cta_w&x={x}&y={y}&l={z}";



ServiceUrlConfig.tdt_government_base_url="http://10.162.10.73:8089/fmserver";
ServiceUrlConfig.tdt_government_vec_c_url = ServiceUrlConfig.tdt_government_base_url+ "/service/mongo_vec_c/wmts";
ServiceUrlConfig.tdt_government_cva_c_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cva_c/wmts";
ServiceUrlConfig.tdt_government_img_c_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_img_c/wmts";
ServiceUrlConfig.tdt_government_cia_c_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cia_c/wmts";
ServiceUrlConfig.tdt_government_ter_c_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_vec_c/wmts";
ServiceUrlConfig.tdt_government_cta_c_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cva_c/wmts";


ServiceUrlConfig.tdt_government_vec_w_url = ServiceUrlConfig.tdt_government_base_url+ "/service/mongo_vec_c/wmts";
ServiceUrlConfig.tdt_government_cva_w_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cva_c/wmts";
ServiceUrlConfig.tdt_government_img_w_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_img_c/wmts";
ServiceUrlConfig.tdt_government_cia_w_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cia_c/wmts";
ServiceUrlConfig.tdt_government_ter_w_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_vec_c/wmts";
ServiceUrlConfig.tdt_government_cta_w_url =ServiceUrlConfig.tdt_government_base_url+  "/service/mongo_cva_c/wmts";

ServiceUrlConfig.tdt_xyz_government_base_url="http://10.162.10.73:8089/fmserver";
ServiceUrlConfig.tdt_xyz_government_vec_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_vec_c/xyz?T=mongo_vec_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cva_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_cva_c/xyz?T=mongo_cva_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_img_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_img_c/xyz?T=mongo_img_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cia_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_cia_c/xyz?T=mongo_cia_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_ter_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_vec_c/xyz?T=mongo_vec_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cta_c_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_vec_c/xyz?T=mongo_vec_c&x={x}&y={y}&l={z}";

ServiceUrlConfig.tdt_xyz_government_vec_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_vec_c/xyz?T=mongo_vec_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cva_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_cva_c/xyz?T=mongo_cva_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_img_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_img_c/xyz?T=mongo_img_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cia_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_cia_c/xyz?T=mongo_cia_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_ter_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_vec_c/xyz?T=mongo_vec_c&x={x}&y={y}&l={z}";
ServiceUrlConfig.tdt_xyz_government_cta_w_url =ServiceUrlConfig.tdt_xyz_government_base_url + "/service/mongo_cva_c/xyz?T=mongo_cva_c&x={x}&y={y}&l={z}";




ServiceUrlConfig.tdt_service_public_base_url="http://api.tianditu.gov.cn";
// // //测试用
// ServiceUrlConfig.tdt_service_public_base_url="http://127.0.0.1:8089/fmserver";

ServiceUrlConfig.tdt_service_public_busTransfer_url ="/transit";
ServiceUrlConfig.tdt_service_public_district_url ="/administrative";
ServiceUrlConfig.tdt_service_public_drive_url ="/drive";

ServiceUrlConfig.tdt_service_public_query_url ="/search";

// //测试用
// ServiceUrlConfig.tdt_service_public_query_url ="/poi/search";

ServiceUrlConfig.tdt_service_public_reverse_address_url="/geocoder";


ServiceUrlConfig.tdt_service_government_base_url="http://10.162.10.73:8089/fmserver";
ServiceUrlConfig.tdt_service_government_busTransfer_url ="/transit";
ServiceUrlConfig.tdt_service_government_district_url ="/administrative";
ServiceUrlConfig.tdt_service_government_drive_url = "/drive";
ServiceUrlConfig.tdt_service_government_query_url = "/poi/search";
ServiceUrlConfig.tdt_service_government_reverse_address_url="/geocoder";

//平台基础url
ServiceUrlConfig.platform_base_url = null;


//用户管理系统基础url
// ServiceUrlConfig.userManagerSytem_base_url_government="http://10.162.10.74:8080/EzManager6";

ServiceUrlConfig.userManagerSytem_base_url_government="http://139.198.12.200:8040";

//


//平台运维基础url_公众网，正式环境
 ServiceUrlConfig.platform_base_url_public = "http://gansu.tianditu.gov.cn/platformmaintenance-linxia";

 //公司服务器环境部署
// ServiceUrlConfig.platform_base_url_public = "http://222.128.56.122:8175/platformmaintenance";

//正式环境 186测试
// ServiceUrlConfig.platform_base_url_public = "http://192.168.0.186:8087/platformmaintenance";


//平台运维基础url_政务网
ServiceUrlConfig.platform_base_url_government = "http://10.162.10.74:8087/platformmaintenance";



//收藏文件夹
ServiceUrlConfig.platform_collectfolder_selectByFilter="/usercollectfolder/selectbyfilter";
ServiceUrlConfig.platform_collectfolder_selectCountByFilter="/usercollectfolder/selectcountbyfilter";
ServiceUrlConfig.platform_collectfolder_deleteMulti="/usercollectfolder/deletemulti";
ServiceUrlConfig.platform_collectfolder_add="/usercollectfolder/create";
ServiceUrlConfig.platform_collectfolder_update="/usercollectfolder/update";

//收藏文件项
ServiceUrlConfig.platform_collectitem_selectByFilter="/usercollectitem/selectbyfilter";
ServiceUrlConfig.platform_collectitem_selectCountByFilter="/usercollectitem/selectcountbyfilter";
ServiceUrlConfig.platform_collectitem_deleteMulti="/usercollectitem/deletemulti";
ServiceUrlConfig.platform_collectitem_add="/usercollectitem/create";
ServiceUrlConfig.platform_collectitem_update="/usercollectitem/update";


ServiceUrlConfig.platform_tdtsso_fullLogin = null;
ServiceUrlConfig.platform_tdtsso_fullLogout = null;

ServiceUrlConfig.platform_tdtsso_login = "/tdtsso/onlinemaplogin";
ServiceUrlConfig.platform_tdtsso_logout = "/tdtsso/onlinemaplogout";
ServiceUrlConfig.platform_tdtsso_getsession="/tdtsso/onlinemapgetusersession";


ServiceUrlConfig.userManagerSytem_user_login_government="/token/generateToken";
ServiceUrlConfig.userManagerSytem_user_logout_government="/user/logout";
ServiceUrlConfig.userManagerSytem_user_getsession_government="";

// 底图配置
ServiceUrlConfig.platform_baseLayerConfig_selectByFilter = "/tdtserviceinfo/selectbyfilter";

//门户
ServiceUrlConfig.platform_href_portal="http://gansu.tianditu.gov.cn";

//链接-专题图层
ServiceUrlConfig.platform_href_thematicLayer = "http://gansu.tianditu.gov.cn/subject/map.html";

//开发资源
ServiceUrlConfig.platform_href_development_center = "http://lbs.tianditu.gov.cn";

//链接-典型应用
ServiceUrlConfig.platform_href_typical_app = "http://gansu.tianditu.gov.cn/thematicApp";

//资源中心
ServiceUrlConfig.platform_href_resourceCenter="http://gansu.tianditu.gov.cn/serviceresource";

//链接-应急服务
ServiceUrlConfig.platform_href_emergency_service="http://yjfw.tianditu.gov.cn/yjzt/";